'use client';

import { useEmbedResizer } from '../../../hooks/useEmbedResizer';

/**
 * Resize the iFrame height to match the content height
 */
export const EmbedResizer = () => {
    useEmbedResizer();

    return null;
};
